import axios from '@/libs/api.request'
// 产品列表
export const getNewProductList = (params) => {
    return axios.request({
        url: '/new_product',
        method: 'get',
        params: params
    })
}

// 产品详情
export const getnewProductDetail = (params) => {
    return axios.request({
        url: `/new_product/${params.id}`,
        method: 'get'
        // params: params
    })
}

// 类别
export const newProductCategory = (params) => {
    return axios.request({
        url: '/new_product_category',
        method: 'get',
        params: params
    })
}
// 离心方案列表
export const getCenProgramme = (params) => {
    return axios.request({
        url: `/product`,
        method: 'post',
        data: params
    })
}
// 离心方案详情
export const getProgramme = (params) => {
    return axios.request({
        url: `/product/${params.id}`,
        method: 'post',
    })
}
// 产品特性分类
export const getProCate = (params) => {
    return axios.request({
        url: `/category/0?type=${params.type}`,
        method: 'get',
        params: params
    })
}
// 绑定列表
export const getProBindList = (params) => {
    return axios.request({
        url: `/video_pdf?module=${params.module}&type=${params.type}&title=${params.title || ''}&page=${params.page}&cid=${params.cid}&parent_cid=${params.parent_cid || ''}`,
        method: 'get',
    })
}
export const getProductList = (params) => {
    return axios.request({
        url: `/product/564`,
        method: 'post',
        data: params
    })
}
export const getMainDesc = (params) => { // 获取维护保养的描述
    return axios.request({
        url: `/video_pdf_desc/${params.module}`,
        method: 'get',
        params: params
    })
}

export const createdLabel = (params) => { // 添加离心/移液 标签
    return axios.request({
        url: `/tagToUsers`,
        method: 'post',
        data: params
    })
}

